import { AutoComplete } from 'antd';
import ReactInputMask, { Props as ReactInputMaskProps } from 'react-input-mask';
import { styled } from 'styled-components';

export interface InputMaskProps extends ReactInputMaskProps {
  error?: boolean;
}

export interface InputProps {
  error?: boolean;
}

const inputStyle = `
  border: none;
  background-color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  box-sizing: border-box;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 16px;
  width: 100%;
  margin-top: 5px;
  height: 40px;

  + span {
    color: var(--red2);
    font-size: 14px;
  }
`;

export const Container = styled.div`
  width: 100%;
  
  label {
    font-size: 14px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 4px;
  }

  span {
    color: var(--red2);
    font-size: 14px;
  }
`;

export const InputMask = styled(ReactInputMask)<InputMaskProps>`
  ${inputStyle}
  border: 1px solid ${({ error }) => error ? 'var(--red2)' : '#bfbfbf'};
`;

export const Input = styled.input<InputProps>`
  ${inputStyle}
  border: 1px solid ${({ error }) => error ? 'var(--red2)' : '#bfbfbf'};
`;

export const InputAutoCompleteContainer = styled(AutoComplete)<{ error?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  margin-top: 5px;
  border-radius: 6px;
  border: none;
  border: 1px solid ${({ error }) => error ? 'var(--red2)' : '#bfbfbf'};
`;